module.exports = __webpack_public_path__ + "static/media/wedding.14930709.jpg";